import { PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS } from '../PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS';
import { PartyBehaviorCompatibilityOptionIdType } from '../types';

export const getPartyBehaviorCompatibilityTitleById = (
  id: PartyBehaviorCompatibilityOptionIdType | null,
): string | null => {
  if (!id) return null;
  return (
    PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS.find((option) => option.id === id)
      ?.title || null
  );
};

const DEFAULT: PartyBehaviorCompatibilityOptionIdType = 'be_center';
export const getPartyBehaviorCompatibilityIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): PartyBehaviorCompatibilityOptionIdType | null => {
  const id = PARTY_BEHAVIOR_COMPATIBILITY_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
